import { isRedBlackTree as isRedBlackTree$1, empty as empty$1, fromIterable as fromIterable$1, make as make$1, atForwards, atBackwards, findAll as findAll$1, findFirst as findFirst$1, first as first$1, getAt as getAt$1, getOrder as getOrder$1, greaterThanForwards, greaterThanBackwards, greaterThanEqualForwards, greaterThanEqualBackwards, has as has$1, insert as insert$1, keysForward, keysBackward, last as last$1, lessThanForwards, lessThanBackwards, lessThanEqualForwards, lessThanEqualBackwards, forEach as forEach$1, forEachGreaterThanEqual as forEachGreaterThanEqual$1, forEachLessThan as forEachLessThan$1, forEachBetween as forEachBetween$1, reduce as reduce$1, removeFirst as removeFirst$1, reversed as reversed$1, size as size$1, valuesForward, valuesBackward } from '../../internal/RedBlackTree.esm.js';
import { Direction as Direction$1 } from '../../internal/RedBlackTree/iterator.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbol
 */

/**
 * @since 2.0.0
 * @category constants
 */
const Direction = Direction$1;

/**
 * A Red-Black Tree.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category refinements
 */
const isRedBlackTree = isRedBlackTree$1;

/**
 * Creates an empty `RedBlackTree`.
 *
 * @since 2.0.0
 * @category constructors
 */
const empty = empty$1;

/**
 * Constructs a new tree from an iterable of key-value pairs.
 *
 * @since 2.0.0
 * @category constructors
 */
const fromIterable = fromIterable$1;

/**
 * Constructs a new `RedBlackTree` from the specified entries.
 *
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * Returns an iterator that points to the element at the specified index of the
 * tree.
 *
 * **Note**: The iterator will run through elements in order.
 *
 * @since 2.0.0
 * @category traversing
 */
const at = atForwards;

/**
 * Returns an iterator that points to the element at the specified index of the
 * tree.
 *
 * **Note**: The iterator will run through elements in reverse order.
 *
 * @since 2.0.0
 * @category traversing
 */
const atReversed = atBackwards;

/**
 * Finds all values in the tree associated with the specified key.
 *
 * @since 2.0.0
 * @category elements
 */
const findAll = findAll$1;

/**
 * Finds the first value in the tree associated with the specified key, if it exists.
 *
 * @category elements
 * @since 2.0.0
 */
const findFirst = findFirst$1;

/**
 * Returns the first entry in the tree, if it exists.
 *
 * @since 2.0.0
 * @category getters
 */
const first = first$1;

/**
 * Returns the element at the specified index within the tree or `None` if the
 * specified index does not exist.
 *
 * @since 2.0.0
 * @category elements
 */
const getAt = getAt$1;

/**
 * Gets the `Order<K>` that the `RedBlackTree<K, V>` is using.
 *
 * @since 2.0.0
 * @category getters
 */
const getOrder = getOrder$1;

/**
 * Returns an iterator that traverse entries in order with keys greater than the
 * specified key.
 *
 * @since 2.0.0
 * @category traversing
 */
const greaterThan = greaterThanForwards;

/**
 * Returns an iterator that traverse entries in reverse order with keys greater
 * than the specified key.
 *
 * @since 2.0.0
 * @category traversing
 */
const greaterThanReversed = greaterThanBackwards;

/**
 * Returns an iterator that traverse entries in order with keys greater than or
 * equal to the specified key.
 *
 * @since 2.0.0
 * @category traversing
 */
const greaterThanEqual = greaterThanEqualForwards;

/**
 * Returns an iterator that traverse entries in reverse order with keys greater
 * than or equal to the specified key.
 *
 * @since 2.0.0
 * @category traversing
 */
const greaterThanEqualReversed = greaterThanEqualBackwards;

/**
 * Finds the item with key, if it exists.
 *
 * @since 2.0.0
 * @category elements
 */
const has = has$1;

/**
 * Insert a new item into the tree.
 *
 * @since 2.0.0
 */
const insert = insert$1;

/**
 * Get all the keys present in the tree in order.
 *
 * @since 2.0.0
 * @category getters
 */
const keys = keysForward;

/**
 * Get all the keys present in the tree in reverse order.
 *
 * @since 2.0.0
 * @category getters
 */
const keysReversed = keysBackward;

/**
 * Returns the last entry in the tree, if it exists.
 *
 * @since 2.0.0
 * @category getters
 */
const last = last$1;

/**
 * Returns an iterator that traverse entries in order with keys less than the
 * specified key.
 *
 * @since 2.0.0
 * @category traversing
 */
const lessThan = lessThanForwards;

/**
 * Returns an iterator that traverse entries in reverse order with keys less
 * than the specified key.
 *
 * @since 2.0.0
 * @category traversing
 */
const lessThanReversed = lessThanBackwards;

/**
 * Returns an iterator that traverse entries in order with keys less than or
 * equal to the specified key.
 *
 * @since 2.0.0
 * @category traversing
 */
const lessThanEqual = lessThanEqualForwards;

/**
 * Returns an iterator that traverse entries in reverse order with keys less
 * than or equal to the specified key.
 *
 * @since 2.0.0
 * @category traversing
 */
const lessThanEqualReversed = lessThanEqualBackwards;

/**
 * Execute the specified function for each node of the tree, in order.
 *
 * @since 2.0.0
 * @category traversing
 */
const forEach = forEach$1;

/**
 * Visit each node of the tree in order with key greater then or equal to max.
 *
 * @since 2.0.0
 * @category traversing
 */
const forEachGreaterThanEqual = forEachGreaterThanEqual$1;

/**
 * Visit each node of the tree in order with key lower then max.
 *
 * @since 2.0.0
 * @category traversing
 */
const forEachLessThan = forEachLessThan$1;

/**
 * Visit each node of the tree in order with key lower than max and greater
 * than or equal to min.
 *
 * @since 2.0.0
 * @category traversing
 */
const forEachBetween = forEachBetween$1;

/**
 * Reduce a state over the entries of the tree.
 *
 * @since 2.0.0
 * @category folding
 */
const reduce = reduce$1;

/**
 * Removes the entry with the specified key, if it exists.
 *
 * @since 2.0.0
 */
const removeFirst = removeFirst$1;

/**
 * Traverse the tree in reverse order.
 *
 * @since 2.0.0
 * @category traversing
 */
const reversed = reversed$1;

/**
 * Returns the size of the tree.
 *
 * @since 2.0.0
 * @category getters
 */
const size = size$1;

/**
 * Get all values present in the tree in order.
 *
 * @since 2.0.0
 * @category getters
 */
const values = valuesForward;

/**
 * Get all values present in the tree in reverse order.
 *
 * @since 2.0.0
 * @category getters
 */
const valuesReversed = valuesBackward;

export { Direction, at, atReversed, empty, findAll, findFirst, first, forEach, forEachBetween, forEachGreaterThanEqual, forEachLessThan, fromIterable, getAt, getOrder, greaterThan, greaterThanEqual, greaterThanEqualReversed, greaterThanReversed, has, insert, isRedBlackTree, keys, keysReversed, last, lessThan, lessThanEqual, lessThanEqualReversed, lessThanReversed, make, reduce, removeFirst, reversed, size, values, valuesReversed };
